import axios from 'axios';

export default {
  getTenantsList(context) {
    context.commit('SET_LOADING', true);
    axios
      .get(`${process.env.VUE_APP_API_URL}/auth/tenants`)
      .then(result => {
        context.commit('SET_TENANTS_LIST', result.data.data.items);
        context.commit('SET_LOADING', false);
      })
      .catch(err => {
        console.log(`[Tenants] - Error trying to getTenantsList:`, err);
        context.commit('SET_LOADING', false);
      });
  },
  getUsersTenantsList(context, userId) {
    context.commit('SET_LOADING', true);
    return axios
      .get(`${process.env.VUE_APP_API_URL}/profile/${userId}/tenants`)
      .then(result => {
        context.commit('SET_LOADING', false);
        return result.data.data;
      })
      .catch(err => {
        console.log(`[Tenants] - Error trying to getUsersTenantsList:`, err);
        context.commit('SET_LOADING', false);
      });
  },
  remove(context, { userId, tenants }) {
    context.commit('SET_LOADING', true);
    return axios
      .post(`${process.env.VUE_APP_API_URL}/auth/tenants/unassign`, {
        tenants,
        user: userId
      })
      .then(result => {
        context.commit('SET_LOADING', false);
        this.dispatch('snackbar/update', {
          text: `Successfully unassigned user ${userId} from tenants [${tenants}] `,
          color: 'success',
          open: true
        });
      })
      .catch(err => {
        context.commit('SET_LOADING', false);
        this.dispatch('snackbar/update', {
          text: `Error trying to unassign user ${userId} from tenants [${tenants}]`,
          color: 'warning',
          open: true
        });
      });
  },
  add(context, { userId, tenantId }) {
    context.commit('SET_LOADING', true);
    return axios
      .post(`${process.env.VUE_APP_API_URL}/auth/tenants/assign`, {
        tenants: [tenantId],
        user: userId
      })
      .then(result => {
        context.commit('SET_LOADING', false);
        this.dispatch('snackbar/update', {
          text: `Successfully assigned user ${userId} to tenant ` + tenantId,
          color: 'success',
          open: true
        });
      })
      .catch(err => {
        context.commit('SET_LOADING', false);
        this.dispatch('snackbar/update', {
          text: `Error trying to assign user ${userId} to tenant ` + tenantId,
          color: 'warning',
          open: true
        });
      });
  }
};
